import { Grid, useMediaQuery } from '@mui/material'
import React from 'react'
import CallIcon from '@mui/icons-material/Call';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import ReplyIcon from '@mui/icons-material/Reply';
import ListIcon from '@mui/icons-material/List';
import styles from '../../../../../../../assets/styles/componentStyles/templatemessages.module.scss'
import { getTemplateDetails, getWhatsappTemplateButtonTypeReponse } from '../../../../../../../models/axiosModel';
import carouselStyles from '../../../../../../../assets/styles/componentStyles/carouselCard.module.scss'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"
import { replacingTemplateMarkdownText } from '../../../../../../../utils/constants';
import { secondaryColor } from '../../../../../../../utils/colors';
import TemplatePreviewGlobal from './templatePreviewGlobal';
import { getSubButtonIcon, subButtonTypeIconMap } from '../../../../../templatelibrary/constant';

interface TemplatePreviewInterface {
    // metaInformation: createWhatsappTemplatePayload,
    metaInformation: getTemplateDetails | null,
    flagCampaign?: boolean,
    flagTemplatePopup?: boolean,
    whatsappTemplateButtonGenericData?: getWhatsappTemplateButtonTypeReponse[] | null
}

const TemplatePreviewCarouselView = (props: TemplatePreviewInterface) => {
    const isScreenBelow1000 = useMediaQuery('(max-width : 1200px) and (min-width: 0px)');

    function SampleNextArrow(props: any) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{
                    ...style,
                    display: "flex",
                    // background: '#F3F5F9',
                    background: secondaryColor,
                    padding: '3px 3px 2px',
                    borderRadius: '50%',
                    boxShadow: "0px 0px 3px rgba(0,0,0,0.25)"
                    // '--user-msg-bg-color': chatBotDetail?.chatbot_theme?.user_msg_bg_color || '#F3F5F9'
                }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props: any) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{
                    ...style,
                    display: "block",
                    padding: '3px 3px 1px',
                    borderRadius: '50%',
                    background: secondaryColor,
                    boxShadow: "0px 0px 3px rgba(0,0,0,0.25)"
                }}

                onClick={onClick}
            />
        );
    }

    const messageText = (value: any, type: string) => {
        let data, template: string = "";
        if (type.toLowerCase() === "body") {
            data = value
            template = data?.whatsapp_template_body_value
            // Replacing placeholders with sample values
            data?.whatsapp_template_body_variable_data?.forEach((variable: any) => {
                const placeholder = variable.whatsapp_template_dynamic_variable_key
                const sampleValue = variable.whatsapp_template_dynamic_variable_sample_value;
                if (sampleValue) {
                    template = template.replaceAll(placeholder, sampleValue);
                }
            });
        }
        else if (type.toLowerCase() === "cardheader") {
            data = value;
            template = data?.whatsapp_template_header_data_value
            // Replacing placeholders with sample values
            data.whatsapp_template_header_variable_data?.forEach((variable: any) => {
                const placeholder = variable.whatsapp_template_dynamic_variable_key
                const sampleValue = variable.whatsapp_template_dynamic_variable_sample_value;
                if (sampleValue) {
                    template = template?.replaceAll(placeholder, sampleValue);
                }
            });
        }
        else if (type.toLowerCase() === "header") {
            data = value;
            template = data?.whtatsapp_carousel_header
            // Replacing placeholders with sample values
            data?.whtatsapp_carousel_header_variable_data?.forEach((variable: any) => {
                const placeholder = variable.whatsapp_template_dynamic_variable_key
                const sampleValue = variable.whatsapp_template_dynamic_variable_sample_value;
                if (sampleValue) {
                    template = template.replaceAll(placeholder, sampleValue);
                }
            });
        }
        else {
            data = value;
            template = data?.whatsapp_template_footer_value || ""
        }


        // needed transformation
        return replacingTemplateMarkdownText(template);
    }

    const getSubButtonText = (subBtnData: any) => {
        let fieldVal = subBtnData?.whatsapp_template_button_sub_type_field_data?.filter((field: any) => field.field_name == "Button Text")[0]

        switch (fieldVal?.field_static_value_flag) {
            case true:
                return fieldVal?.field_static_value
            case false:
                return fieldVal?.whatsapp_template_button_sub_type_field_value
            default:
                return ""
        }
    }

    return (
        <>
            {/* PREVIEW */}
            <Grid item xs={12} id="test" className={styles.templatePreviewMainContainer} sx={{ width: "100%" }}>
                <Grid container alignItems={'center'} direction={"column"} className={props.flagCampaign ? styles.previewCampignMainSecrion : (props.flagTemplatePopup ? styles.previewTemplateMainSection : styles.previewMainSection)} gap={2}>
                    <Grid item paddingBlock={"10px"} textAlign={"center"} style={{ width: "100%" }}>
                        <span className={styles.previewSectionTextStyle}>{props.flagCampaign ? "Preview" : "Preview Section"}</span>
                    </Grid>

                    <Grid item style={{ width: "100%", padding: "0px 10px 0px 25px" }} className={props.flagTemplatePopup ? styles.previewTemplateMainSectionContent : styles.previewMainSectionContent}>
                        <Grid container>
                            <Grid item xs={9.5} className={styles.carouselTemplatePrviewHeadItem}>
                                <pre
                                    className={styles.preTextStyle}
                                    dangerouslySetInnerHTML={{ __html: messageText(props?.metaInformation, "header") }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div className={carouselStyles.slider_container} style={{ maxWidth: "325px" }}>
                                    <Slider
                                        swipe={isScreenBelow1000 ? true : false}
                                        arrows={true}
                                        dots={false}
                                        infinite={false}
                                        autoplay={false}
                                        variableWidth={true}
                                        className={carouselStyles.chatbot_click_slider_template}
                                        slidesToShow={1}
                                        slidesToScroll={1}
                                        nextArrow={<SampleNextArrow className={carouselStyles.chat_slider_next_arrow} />}
                                        prevArrow={<SamplePrevArrow className={carouselStyles.chat_slider_prev_arrow} />}
                                    // speed={400}
                                    >
                                        {props.metaInformation?.whatsapp_template_data?.map((cards) =>
                                            <Grid item padding={cards?.whatsapp_template_header?.whatsapp_template_header_data && cards?.whatsapp_template_header.whatsapp_template_header_data.length > 0 && cards?.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_data_value ? "0px" : "0px"} className={styles.previewSectionCardBlock}>
                                                <Grid container direction={"column"} flexWrap={"nowrap"}>
                                                    <TemplatePreviewGlobal 
                                                        headerType={cards?.whatsapp_template_header?.whatsapp_template_header_type_name || ""}
                                                        headerURL={cards?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_data_value || cards?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data?.[0]?.whatsapp_template_dynamic_variable_sample_value}
                                                        headerVaraibleData={cards?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data ?? []}
                                                        isFooter={cards?.whatsapp_template_footer && cards?.whatsapp_template_footer?.whatsapp_template_footer_value && cards?.whatsapp_template_footer?.whatsapp_template_footer_value?.length > 0}
                                                        headerText={messageText(cards?.whatsapp_template_header?.whatsapp_template_header_data[0], "cardheader")}
                                                        bodyText={messageText(cards?.whatsapp_template_body, "body")}
                                                        footerText={messageText(cards?.whatsapp_template_footer, "footer")}
                                                    />

                                                    {/*Carousel Card Button Section */}
                                                    {
                                                        cards?.whatsapp_template_button && cards?.whatsapp_template_button.length > 0 && cards?.whatsapp_template_button.map((btnData: any, ind: number) => {
                                                            return <React.Fragment key={ind}>
                                                                {btnData?.whatsapp_template_button_data?.map((subBtnData: any, index: any) => {
                                                                    return <Grid item key={index} paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                                                                        <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                                                            <Grid item>
                                                                                {
                                                                                    (subBtnData?.whatsapp_template_button_sub_type_name) 
                                                                                    ? subButtonTypeIconMap[subBtnData?.whatsapp_template_button_sub_type_name?.toLowerCase() as keyof typeof subButtonTypeIconMap]
                                                                                    : (props?.whatsappTemplateButtonGenericData && getSubButtonIcon(subBtnData?.whatsapp_template_button_sub_type_id, props?.whatsappTemplateButtonGenericData))
                                                                                }
                                                                            </Grid>
                                                                            <Grid item>
                                                                                {getSubButtonText(subBtnData)}
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                })}
                                                            </React.Fragment>
                                                        })
                                                    }
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Slider>
                                </div>
                            </Grid>
                        </Grid>

                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}

export default TemplatePreviewCarouselView